import React from 'react';
import { Stack, Group } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { Select } from '@mantine/core';
import { Controller, useForm } from 'react-hook-form';
import Button from '../../components/elements/Button';
import { FiCalendar, FiFilter } from 'react-icons/fi';
import dayjs from 'dayjs';
import { dateFormat } from '../../utilities/dataFormat';
import ModalWrapper from '../../components/elements/ModalWrapper';

interface ChartFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (data: any) => void;
  onReset: () => void;
}

const programOptions = [
  { label: 'School of K12 Program', value: 'K12 Program' },
  { label: 'School of Core Competency', value: 'BCC Program' },
  { label: 'English Course', value: 'So English Program' }
];

const ChartFilterModal: React.FC<ChartFilterModalProps> = ({
  isOpen,
  onClose,
  onFilter,
  onReset
}) => {
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      startDate: null,
      endDate: null,
      program: null
    }
  });

  const onSubmit = (data: any) => {
    onFilter(data);
    onClose();
  };

  const handleReset = () => {
    reset({
      startDate: null,
      endDate: null,
      program: null
    });
    onClose();
    onReset();
  };

  return (
    <ModalWrapper isVisible={isOpen} onClose={onClose} title="Filter Chart">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack>
          <Controller
            name="startDate"
            control={control}
            render={({ field }) => (
              <DatePickerInput
                label="Start Date"
                placeholder="Select start date"
                rightSection={<FiCalendar />}
                {...field}
                onChange={(date) =>
                  field.onChange(
                    dayjs(date).format(dateFormat('filter-format'))
                  )
                }
                value={field.value ? new Date(field.value) : null}
              />
            )}
          />
          <Controller
            name="endDate"
            control={control}
            render={({ field }) => (
              <DatePickerInput
                label="End Date"
                placeholder="Select end date"
                rightSection={<FiCalendar />}
                {...field}
                onChange={(date) =>
                  field.onChange(
                    dayjs(date).format(dateFormat('filter-format'))
                  )
                }
                value={field.value ? new Date(field.value) : null}
              />
            )}
          />
          <Controller
            name="program"
            control={control}
            render={({ field }) => (
              <Select
                label="Select Program"
                data={programOptions}
                placeholder="Select a program"
                {...field}
              />
            )}
          />
          <Group justify="flex-end" mt="md" gap={10}>
            <Button variant="error-beelajar" onClick={handleReset}>
              Reset Filter
            </Button>
            <Button type="submit">
              <FiFilter />
              Apply Filter
            </Button>
          </Group>
        </Stack>
      </form>
    </ModalWrapper>
  );
};

export default ChartFilterModal;
